export default "__VITE_ASSET__PmULz5O0__"